import React from 'react';
import { Theme, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import IKImage from '../../IKImage/IKImage';
import useStyles from './styles';
import { VideoDifficulty } from '../../../types';

export const LightTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    position: 'relative',
    backgroundColor: 'rgba(163, 163, 245, 1)',
    border: '1px solid rgba(105, 105, 237, 1)',
    color: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    height: 27,
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: '"sofia-pro", sans-serif',
    '&:before': {
      content: '""',
      display: 'block',
      width: 0,
      height: 0,
      position: 'absolute',
      borderRight: '5px solid transparent',
      borderLeft: '5px solid transparent',
      borderTop: '5px solid rgba(163, 163, 245, 1)',
      bottom: -5,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
}))(Tooltip);

interface DifficultyIconProps {
  difficulty: VideoDifficulty;
}

const DifficultyIcon: React.FC<DifficultyIconProps> = ({ difficulty }) => {
  const classes = useStyles();

  return (
    <LightTooltip placement="top" title={difficulty?.title} className={classes.difficultyBtn}>
      <div className={classes.difIconWrap}>
        <IKImage
          className={classes.difIcon}
          path={difficulty?.icon_url}
          alt={difficulty?.title}
          draggable={false}
        />
      </div>
    </LightTooltip>
  );
};

export default DifficultyIcon;
